'use client';
import React, { useEffect, useRef } from 'react';
import type { BookingStatus } from '@/components/ui/StatusBadge';
import StatusBadge from '@/components/ui/StatusBadge';

const ALL_STATUSES: BookingStatus[] = ['pending', 'confirmed', 'inprogress', 'completed', 'cancelled', 'noshow'];

interface StatusChangeDropdownProps {
  currentStatus: BookingStatus;
  onSelect: (s: BookingStatus) => void;
  onClose: () => void;
}

export default function StatusChangeDropdown({ currentStatus, onSelect, onClose }: StatusChangeDropdownProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="absolute left-0 top-full mt-1 z-50 bg-card border border-border rounded-xl shadow-modal py-1.5 min-w-[160px] animate-fade-in"
      role="listbox"
      aria-label="Change booking status"
    >
      <p className="text-[10px] font-600 text-muted-foreground uppercase tracking-wider px-3 py-1.5">Change Status</p>
      {ALL_STATUSES.map((s) => (
        <button
          key={`status-opt-${s}`}
          onClick={() => onSelect(s)}
          className={`w-full flex items-center px-3 py-2 hover:bg-muted transition-colors text-left ${
            s === currentStatus ? 'bg-secondary' : ''
          }`}
          role="option"
          aria-selected={s === currentStatus}
        >
          <StatusBadge status={s} size="sm" />
          {s === currentStatus && (
            <span className="ml-auto text-primary text-xs">✓</span>
          )}
        </button>
      ))}
    </div>
  );
}